import pdfMake, {
  userMark,
  setMyConfig,
  makeTableContent
} from "../../../utils/pdf";

function liquidacionDetallePdf(payload) {
  const columns = [
    "fecha:wauto",
    "servicio:w*",
    "hotel:w*",
    {
      key: "tipo",
      label: "Tipo",
      width: "auto"
    },
    {
      key: "moneda",
      label: "Moneda",
      width: "auto"
    },
    {
      key: "monto",
      label: "Monto",
      width: 50
    }
  ];

  const tables = payload.liquidaciones.map(liquidacion => {
    const table = makeTableContent([...liquidacion.items], columns);

    return [
      {
        text: "NOMBRE: " + liquidacion.pasajero,
        margin: [0, 0, 0, 3]
      },
      table,
      {
        text: "",
        margin: [0, 0, 0, 12]
      }
    ];
  });

  pdfMake
    .createPdf({
      info: {
        title: `Reporte Liquidación`
      },
      content: [
        {
          text: "Reporte Liquidación",
          style: "h1"
        },
        {
          columns: [
            {
              text: `Agencia: ${payload.header.agencia}`,
              width: "auto"
            },
            {
              text: `Fecha Inicio: ${payload.header.fechaInicio}`,
              width: "auto"
            },
            {
              text: `Fecha Fin: ${payload.header.fechaFin}`,
              width: "auto"
            }
          ],
          margin: [0, 0, 0, 12]
        },
        ...tables,
        ...userMark(payload.userMark, payload.dateMark)
      ],
      ...setMyConfig("vertical")
    })
    .print();
}

export default liquidacionDetallePdf;
